/* eslint-disable */
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */
/** @typedef {{}} Widget_Action_CopiedInputs */
/** @typedef {{}} Widget_Bag_ChangeInputs */
/** @typedef {{}} Widget_Bag_CheckoutInputs */
/** @typedef {{}} Widget_Bag_CloseInputs */
/** @typedef {{ title: NonNullable<unknown> }} Widget_Bag_DecreaseInputs */
/** @typedef {{ title: NonNullable<unknown> }} Widget_Bag_IncreaseInputs */
/** @typedef {{}} Widget_Bag_LabelInputs */
/** @typedef {{ count: NonNullable<unknown> }} Widget_Bag_OpenInputs */
/** @typedef {{}} Widget_Bag_RemoveInputs */
/** @typedef {{}} Widget_Bag_SavingsInputs */
/** @typedef {{}} Widget_Bag_ShippingInputs */
/** @typedef {{}} Widget_Bag_Shipping_ValueInputs */
/** @typedef {{}} Widget_Bag_SubtotalInputs */
/** @typedef {{}} Widget_Bag_SyncedInputs */
/** @typedef {{}} Widget_Bag_TitleInputs */
/** @typedef {{}} Widget_Bag_TotalInputs */
/** @typedef {{}} Widget_Blocks_LoadingInputs */
/** @typedef {{}} Widget_Blocks_PendingInputs */
/** @typedef {{}} Widget_Blocks_Refresh_FailedInputs */
/** @typedef {{}} Widget_Board_OpenInputs */
/** @typedef {{}} Widget_Board_ShowingInputs */
/** @typedef {{}} Widget_Cart_Add_FailedInputs */
/** @typedef {{ total: NonNullable<unknown> }} Widget_Cart_Add_TotalInputs */
/** @typedef {{}} Widget_Cart_AddingInputs */
/** @typedef {{}} Widget_Cart_Adding_ShortInputs */
/** @typedef {{ count: NonNullable<unknown> }} Widget_Cart_All_In_CartInputs */
/** @typedef {{ count: NonNullable<unknown> }} Widget_Cart_AvailableInputs */
/** @typedef {{ to: NonNullable<unknown>, from: NonNullable<unknown> }} Widget_Cart_Change_FailedInputs */
/** @typedef {{}} Widget_Cart_Change_UnconfirmedInputs */
/** @typedef {{ from: NonNullable<unknown>, to: NonNullable<unknown> }} Widget_Cart_ChangesInputs */
/** @typedef {{}} Widget_Cart_Check_AgainInputs */
/** @typedef {{}} Widget_Cart_CheckingInputs */
/** @typedef {{}} Widget_Cart_Checking_ShortInputs */
/** @typedef {{ count: NonNullable<unknown>, available: NonNullable<unknown> }} Widget_Cart_Clamp_AvailableInputs */
/** @typedef {{ count: NonNullable<unknown>, inCart: NonNullable<unknown> }} Widget_Cart_Clamp_In_CartInputs */
/** @typedef {{}} Widget_Cart_DecreaseInputs */
/** @typedef {{}} Widget_Cart_Edit_TitleInputs */
/** @typedef {{}} Widget_Cart_Enter_QuantityInputs */
/** @typedef {{ count: NonNullable<unknown> }} Widget_Cart_In_CartInputs */
/** @typedef {{}} Widget_Cart_IncreaseInputs */
/** @typedef {{}} Widget_Cart_LowestInputs */
/** @typedef {{}} Widget_Cart_MissingInputs */
/** @typedef {{}} Widget_Cart_New_QuantityInputs */
/** @typedef {{ count: NonNullable<unknown> }} Widget_Cart_Now_In_CartInputs */
/** @typedef {{ name: NonNullable<unknown>, value: NonNullable<unknown> }} Widget_Cart_Option_HeadingInputs */
/** @typedef {{}} Widget_Cart_QuantityInputs */
/** @typedef {{}} Widget_Cart_Read_FailedInputs */
/** @typedef {{}} Widget_Cart_Receipt_AddedInputs */
/** @typedef {{ added: NonNullable<unknown>, count: NonNullable<unknown> }} Widget_Cart_Receipt_MergedInputs */
/** @typedef {{ added: NonNullable<unknown>, requested: NonNullable<unknown> }} Widget_Cart_Receipt_PartialInputs */
/** @typedef {{ count: NonNullable<unknown> }} Widget_Cart_Receipt_QtyInputs */
/** @typedef {{ requested: NonNullable<unknown>, count: NonNullable<unknown> }} Widget_Cart_Receipt_ShortInputs */
/** @typedef {{ requested: NonNullable<unknown>, count: NonNullable<unknown> }} Widget_Cart_Receipt_Short_MoreInputs */
/** @typedef {{}} Widget_Cart_Receipt_UpdatedInputs */
/** @typedef {{}} Widget_Cart_RejectedInputs */
/** @typedef {{}} Widget_Cart_RetryInputs */
/** @typedef {{ count: NonNullable<unknown> }} Widget_Cart_Retry_SetInputs */
/** @typedef {{ options: NonNullable<unknown> }} Widget_Cart_SelectInputs */
/** @typedef {{ variant: NonNullable<unknown>, count: NonNullable<unknown> }} Widget_Cart_SummaryInputs */
/** @typedef {{ count: NonNullable<unknown> }} Widget_Cart_Summary_DefaultInputs */
/** @typedef {{}} Widget_Cart_UnchangedInputs */
/** @typedef {{}} Widget_Cart_UnconfirmedInputs */
/** @typedef {{}} Widget_Cart_UpdateInputs */
/** @typedef {{}} Widget_Cart_UpdatingInputs */
/** @typedef {{}} Widget_Cart_Updating_ShortInputs */
/** @typedef {{ value: NonNullable<unknown> }} Widget_Cart_Value_Sold_OutInputs */
/** @typedef {{ variant: NonNullable<unknown> }} Widget_Cart_Variant_Sold_OutInputs */
/** @typedef {{}} Widget_Compare_Add_RowInputs */
/** @typedef {{}} Widget_Compare_AskedInputs */
/** @typedef {{ first: NonNullable<unknown>, second: NonNullable<unknown> }} Widget_Compare_CaptionInputs */
/** @typedef {{}} Widget_Compare_DiffersInputs */
/** @typedef {{}} Widget_Compare_FieldInputs */
/** @typedef {{}} Widget_Composer_BusyInputs */
/** @typedef {{}} Widget_Composer_PlaceholderInputs */
/** @typedef {{}} Widget_Composer_SendInputs */
/** @typedef {{}} Widget_Contact_Description_ErrorInputs */
/** @typedef {{}} Widget_Contact_Description_HintInputs */
/** @typedef {{}} Widget_Contact_Description_LabelInputs */
/** @typedef {{}} Widget_Contact_Description_PlaceholderInputs */
/** @typedef {{}} Widget_Contact_DismissInputs */
/** @typedef {{}} Widget_Contact_Email_Error_EmptyInputs */
/** @typedef {{}} Widget_Contact_Email_Error_FormatInputs */
/** @typedef {{}} Widget_Contact_Email_Error_OwnInputs */
/** @typedef {{}} Widget_Contact_Email_FromInputs */
/** @typedef {{}} Widget_Contact_Email_Hint_AccountInputs */
/** @typedef {{}} Widget_Contact_Email_Hint_CheckoutInputs */
/** @typedef {{}} Widget_Contact_Email_LabelInputs */
/** @typedef {{}} Widget_Contact_Email_PlaceholderInputs */
/** @typedef {{}} Widget_Contact_Email_Preview_LabelInputs */
/** @typedef {{}} Widget_Contact_Email_Reply_ToInputs */
/** @typedef {{}} Widget_Contact_Email_SubjectInputs */
/** @typedef {{}} Widget_Contact_Email_ToInputs */
/** @typedef {{}} Widget_Contact_OptionalInputs */
/** @typedef {{}} Widget_Contact_Order_Hint_UnverifiedInputs */
/** @typedef {{}} Widget_Contact_Order_Hint_VerifiedInputs */
/** @typedef {{}} Widget_Contact_Order_LabelInputs */
/** @typedef {{}} Widget_Contact_Order_PlaceholderInputs */
/** @typedef {{}} Widget_Contact_Order_VerifiedInputs */
/** @typedef {{}} Widget_Contact_Product_ViewInputs */
/** @typedef {{ time: NonNullable<unknown> }} Widget_Contact_Products_As_OfInputs */
/** @typedef {{}} Widget_Contact_Products_LegendInputs */
/** @typedef {{}} Widget_Contact_Recipient_LabelInputs */
/** @typedef {{}} Widget_Contact_Reply_NoteInputs */
/** @typedef {{}} Widget_Contact_Request_TypeInputs */
/** @typedef {{}} Widget_Contact_ReviewInputs */
/** @typedef {{}} Widget_Contact_SendInputs */
/** @typedef {{}} Widget_Contact_TitleInputs */
/** @typedef {{}} Widget_Contact_Type_Delivery_IssuesInputs */
/** @typedef {{}} Widget_Contact_Type_Order_CancellationInputs */
/** @typedef {{}} Widget_Contact_Type_Order_ChangesInputs */
/** @typedef {{}} Widget_Contact_Type_Order_StatusInputs */
/** @typedef {{}} Widget_Contact_Type_OtherInputs */
/** @typedef {{}} Widget_Contact_Type_Product_IssuesInputs */
/** @typedef {{}} Widget_Contact_Type_ReturnsInputs */
/** @typedef {{}} Widget_Contact_Type_SubscriptionsInputs */
/** @typedef {{}} Widget_Conversation_LatestInputs */
/** @typedef {{}} Widget_Conversation_MessagesInputs */
/** @typedef {{}} Widget_Drawer_ResizeInputs */
/** @typedef {{}} Widget_Email_Result_Accepted_FactInputs */
/** @typedef {{}} Widget_Email_Result_CheckInputs */
/** @typedef {{}} Widget_Email_Result_EditInputs */
/** @typedef {{}} Widget_Email_Result_EmailInputs */
/** @typedef {{ id: NonNullable<unknown> }} Widget_Email_Result_GroupInputs */
/** @typedef {{}} Widget_Email_Result_NextInputs */
/** @typedef {{}} Widget_Email_Result_Next_BouncedInputs */
/** @typedef {{}} Widget_Email_Result_Next_FailedInputs */
/** @typedef {{ email: NonNullable<unknown> }} Widget_Email_Result_Next_ReplyInputs */
/** @typedef {{}} Widget_Email_Result_Next_SendingInputs */
/** @typedef {{}} Widget_Email_Result_Next_UnknownInputs */
/** @typedef {{}} Widget_Email_Result_RequestInputs */
/** @typedef {{}} Widget_Email_Result_RetryInputs */
/** @typedef {{}} Widget_Email_Result_Sending_ActionInputs */
/** @typedef {{}} Widget_Email_Result_Start_NewInputs */
/** @typedef {{}} Widget_Email_Result_SubmittedInputs */
/** @typedef {{}} Widget_Email_Result_Subtitle_AcceptedInputs */
/** @typedef {{}} Widget_Email_Result_Title_AcceptedInputs */
/** @typedef {{}} Widget_Email_Result_Title_BouncedInputs */
/** @typedef {{}} Widget_Email_Result_Title_DeliveredInputs */
/** @typedef {{}} Widget_Email_Result_Title_FailedInputs */
/** @typedef {{}} Widget_Email_Result_Title_SendingInputs */
/** @typedef {{}} Widget_Email_Result_Title_UnknownInputs */
/** @typedef {{}} Widget_Email_Result_ToInputs */
/** @typedef {{}} Widget_Email_Result_UpdatedInputs */
/** @typedef {{}} Widget_Empty_TitleInputs */
/** @typedef {{}} Widget_Error_Answer_LostInputs */
/** @typedef {{}} Widget_Error_Chat_UnavailableInputs */
/** @typedef {{}} Widget_Error_No_AnswerInputs */
/** @typedef {{}} Widget_Error_Playground_ExpiredInputs */
/** @typedef {{}} Widget_Error_Signin_UnavailableInputs */
/** @typedef {{}} Widget_Evidence_Sold_OutInputs */
/** @typedef {{}} Widget_Evidence_Store_PageInputs */
/** @typedef {{}} Widget_Feedback_CancelInputs */
/** @typedef {{}} Widget_Feedback_DefaultInputs */
/** @typedef {{}} Widget_Feedback_Details_PlaceholderInputs */
/** @typedef {{}} Widget_Feedback_HelpInputs */
/** @typedef {{}} Widget_Feedback_LabelInputs */
/** @typedef {{}} Widget_Feedback_Load_FailedInputs */
/** @typedef {{}} Widget_Feedback_LoadingInputs */
/** @typedef {{}} Widget_Feedback_Network_FailedInputs */
/** @typedef {{}} Widget_Feedback_SendInputs */
/** @typedef {{}} Widget_Feedback_Send_FailedInputs */
/** @typedef {{}} Widget_Feedback_SubmittedInputs */
/** @typedef {{ memberName: NonNullable<unknown> }} Widget_Feedback_Submitted_ByInputs */
/** @typedef {{}} Widget_Feedback_TitleInputs */
/** @typedef {{}} Widget_Footer_Powered_ByInputs */
/** @typedef {{}} Widget_Form_DismissInputs */
/** @typedef {{}} Widget_Generating_CatalogInputs */
/** @typedef {{}} Widget_Generating_DealsInputs */
/** @typedef {{}} Widget_Generating_DetailsInputs */
/** @typedef {{}} Widget_Generating_RacksInputs */
/** @typedef {{}} Widget_Generating_ShelvesInputs */
/** @typedef {{}} Widget_Generating_StillInputs */
/** @typedef {{}} Widget_Generating_StockroomInputs */
/** @typedef {{}} Widget_Header_ClearInputs */
/** @typedef {{}} Widget_Header_CloseInputs */
/** @typedef {{}} Widget_Header_Enter_FullscreenInputs */
/** @typedef {{}} Widget_Header_Enter_SpaceInputs */
/** @typedef {{}} Widget_Header_Exit_FullscreenInputs */
/** @typedef {{}} Widget_Header_Exit_SpaceInputs */
/** @typedef {{}} Widget_Header_MinimizeInputs */
/** @typedef {{}} Widget_Header_StatusInputs */
/** @typedef {{}} Widget_Header_TitleInputs */
/** @typedef {{}} Widget_Launcher_LabelInputs */
/** @typedef {{}} Widget_Loading_ChatInputs */
/** @typedef {{ variant: NonNullable<unknown> }} Widget_Look_In_BagInputs */
/** @typedef {{ label: NonNullable<unknown>, index: NonNullable<unknown>, total: NonNullable<unknown> }} Widget_Look_PositionInputs */
/** @typedef {{ variant: NonNullable<unknown> }} Widget_Look_SelectedInputs */
/** @typedef {{}} Widget_Look_SwapInputs */
/** @typedef {{ role: NonNullable<unknown> }} Widget_Look_Swap_LabelInputs */
/** @typedef {{}} Widget_Message_CopyInputs */
/** @typedef {{}} Widget_Message_DislikeInputs */
/** @typedef {{}} Widget_Message_Feedback_SorryInputs */
/** @typedef {{}} Widget_Message_Feedback_ThanksInputs */
/** @typedef {{}} Widget_Message_ImageInputs */
/** @typedef {{}} Widget_Message_Image_CloseInputs */
/** @typedef {{}} Widget_Message_Image_OpenInputs */
/** @typedef {{}} Widget_Message_Image_UnavailableInputs */
/** @typedef {{}} Widget_Message_LikeInputs */
/** @typedef {{}} Widget_Message_ReplyingInputs */
/** @typedef {{}} Widget_Message_RetryInputs */
/** @typedef {{}} Widget_Message_UndeliveredInputs */
/** @typedef {{}} Widget_Message_UnsupportedInputs */
/** @typedef {{ title: NonNullable<unknown> }} Widget_Notice_Now_ViewingInputs */
/** @typedef {{}} Widget_Order_AdjustmentsInputs */
/** @typedef {{}} Widget_Order_Canceled_ItemsInputs */
/** @typedef {{}} Widget_Order_CancellationInputs */
/** @typedef {{}} Widget_Order_Carrier_UnknownInputs */
/** @typedef {{}} Widget_Order_Check_ActionInputs */
/** @typedef {{}} Widget_Order_ContactInputs */
/** @typedef {{}} Widget_Order_Details_LabelInputs */
/** @typedef {{}} Widget_Order_Empty_TitleInputs */
/** @typedef {{}} Widget_Order_Error_InaccessibleInputs */
/** @typedef {{}} Widget_Order_Error_OfflineInputs */
/** @typedef {{}} Widget_Order_Error_Rate_LimitedInputs */
/** @typedef {{}} Widget_Order_Error_UpstreamInputs */
/** @typedef {{}} Widget_Order_Error_VerificationInputs */
/** @typedef {{ time: NonNullable<unknown> }} Widget_Order_Eta_SourceInputs */
/** @typedef {{}} Widget_Order_Eta_UnknownInputs */
/** @typedef {{}} Widget_Order_Event_WaitingInputs */
/** @typedef {{}} Widget_Order_EyebrowInputs */
/** @typedef {{}} Widget_Order_Failed_TitleInputs */
/** @typedef {{}} Widget_Order_Fulfilled_ItemsInputs */
/** @typedef {{}} Widget_Order_Hidden_TitleInputs */
/** @typedef {{ count: NonNullable<unknown> }} Widget_Order_Item_QuantityInputs */
/** @typedef {{}} Widget_Order_Label_CreatedInputs */
/** @typedef {{}} Widget_Order_LoadingInputs */
/** @typedef {{ count: NonNullable<unknown> }} Widget_Order_More_FulfillmentsInputs */
/** @typedef {{ count: NonNullable<unknown> }} Widget_Order_More_RefundsInputs */
/** @typedef {{ count: NonNullable<unknown> }} Widget_Order_More_ReturnsInputs */
/** @typedef {{ count: NonNullable<unknown> }} Widget_Order_More_TrackingsInputs */
/** @typedef {{}} Widget_Order_No_ShippingInputs */
/** @typedef {{}} Widget_Order_Not_ReceivedInputs */
/** @typedef {{}} Widget_Order_PaymentInputs */
/** @typedef {{}} Widget_Order_Payment_AuthorizedInputs */
/** @typedef {{}} Widget_Order_Payment_PaidInputs */
/** @typedef {{}} Widget_Order_Payment_Partially_PaidInputs */
/** @typedef {{}} Widget_Order_Payment_Partially_RefundedInputs */
/** @typedef {{}} Widget_Order_Payment_PendingInputs */
/** @typedef {{}} Widget_Order_Payment_RefundedInputs */
/** @typedef {{}} Widget_Order_Payment_VoidedInputs */
/** @typedef {{}} Widget_Order_Pending_ItemsInputs */
/** @typedef {{}} Widget_Order_Progress_LabelInputs */
/** @typedef {{}} Widget_Order_Refund_RecordInputs */
/** @typedef {{}} Widget_Order_RetryInputs */
/** @typedef {{ name: NonNullable<unknown> }} Widget_Order_Return_RecordInputs */
/** @typedef {{}} Widget_Order_Ship_ToInputs */
/** @typedef {{}} Widget_Order_Shipped_ItemsInputs */
/** @typedef {{}} Widget_Order_Shipping_UnknownInputs */
/** @typedef {{}} Widget_Order_StatusInputs */
/** @typedef {{}} Widget_Order_Status_CanceledInputs */
/** @typedef {{}} Widget_Order_Status_DeliveredInputs */
/** @typedef {{}} Widget_Order_Status_Partially_ShippedInputs */
/** @typedef {{}} Widget_Order_Status_ShippedInputs */
/** @typedef {{}} Widget_Order_Status_UnfulfilledInputs */
/** @typedef {{}} Widget_Order_Step_ArrivesInputs */
/** @typedef {{}} Widget_Order_Step_DeliveredInputs */
/** @typedef {{}} Widget_Order_Step_PlacedInputs */
/** @typedef {{}} Widget_Order_Step_ShippedInputs */
/** @typedef {{}} Widget_Order_TotalInputs */
/** @typedef {{}} Widget_Order_TrackInputs */
/** @typedef {{}} Widget_Order_Unavailable_TitleInputs */
/** @typedef {{}} Widget_Order_UnknownInputs */
/** @typedef {{}} Widget_Order_VerifiedInputs */
/** @typedef {{ email: NonNullable<unknown> }} Widget_Order_Verified_DetailInputs */
/** @typedef {{}} Widget_Order_ViewInputs */
/** @typedef {{}} Widget_Orders_Limit_ReachedInputs */
/** @typedef {{}} Widget_Orders_List_LabelInputs */
/** @typedef {{}} Widget_Orders_Load_MoreInputs */
/** @typedef {{}} Widget_Orders_LoadingInputs */
/** @typedef {{}} Widget_Orders_Loading_FirstInputs */
/** @typedef {{}} Widget_Orders_Loading_StatusInputs */
/** @typedef {{ count: NonNullable<unknown> }} Widget_Orders_More_ItemsInputs */
/** @typedef {{}} Widget_Orders_Newest_FirstInputs */
/** @typedef {{ number: NonNullable<unknown> }} Widget_Orders_Order_NumberInputs */
/** @typedef {{}} Widget_Orders_Readable_EmptyInputs */
/** @typedef {{ count: NonNullable<unknown> }} Widget_Orders_Show_MoreInputs */
/** @typedef {{}} Widget_Orders_TitleInputs */
/** @typedef {{}} Widget_Peek_OpenInputs */
/** @typedef {{}} Widget_Picker_ConfirmInputs */
/** @typedef {{}} Widget_Picker_ConsumedInputs */
/** @typedef {{}} Widget_Picker_ExitInputs */
/** @typedef {{}} Widget_Picker_FailedInputs */
/** @typedef {{ prompt: NonNullable<unknown> }} Widget_Picker_For_RuleInputs */
/** @typedef {{}} Widget_Picker_HintInputs */
/** @typedef {{}} Widget_Picker_InvalidInputs */
/** @typedef {{}} Widget_Picker_RegionInputs */
/** @typedef {{}} Widget_Picker_ReselectInputs */
/** @typedef {{}} Widget_Picker_RetryInputs */
/** @typedef {{}} Widget_Picker_Rule_GoneInputs */
/** @typedef {{}} Widget_Picker_SaveInputs */
/** @typedef {{}} Widget_Picker_SavingInputs */
/** @typedef {{}} Widget_Picker_Selector_RejectedInputs */
/** @typedef {{}} Widget_Playground_Customer_ActionInputs */
/** @typedef {{}} Widget_Playground_Customer_DescriptionInputs */
/** @typedef {{}} Widget_Playground_Customer_Email_LabelInputs */
/** @typedef {{}} Widget_Playground_Customer_Not_FoundInputs */
/** @typedef {{}} Widget_Preview_ProactiveInputs */
/** @typedef {{}} Widget_Preview_Product_TitleInputs */
/** @typedef {{}} Widget_Proactive_DismissInputs */
/** @typedef {{}} Widget_Product_AddInputs */
/** @typedef {{}} Widget_Product_CartInputs */
/** @typedef {{}} Widget_Product_Load_FailedInputs */
/** @typedef {{ price: NonNullable<unknown> }} Widget_Product_OpeningInputs */
/** @typedef {{}} Widget_Product_Sold_OutInputs */
/** @typedef {{}} Widget_Product_SubscriptionInputs */
/** @typedef {{}} Widget_Replay_Handed_OffInputs */
/** @typedef {{}} Widget_Reply_Card_CurrencyInputs */
/** @typedef {{}} Widget_Reply_Card_DetailsInputs */
/** @typedef {{}} Widget_Reply_Card_ExpiredInputs */
/** @typedef {{}} Widget_Reply_Card_GenericInputs */
/** @typedef {{}} Widget_Reply_Card_Missing_FieldsInputs */
/** @typedef {{}} Widget_Reply_Card_NoticeInputs */
/** @typedef {{}} Widget_Reply_Card_Order_DetailInputs */
/** @typedef {{}} Widget_Reply_Card_Order_ListInputs */
/** @typedef {{}} Widget_Reply_Card_Quick_ActionInputs */
/** @typedef {{}} Widget_Reply_Card_RevokedInputs */
/** @typedef {{}} Widget_Reply_Card_Support_RequestInputs */
/** @typedef {{}} Widget_Reply_Card_VerificationInputs */
/** @typedef {{}} Widget_Reply_EmptyInputs */
/** @typedef {{}} Widget_Reply_Notice_DismissInputs */
/** @typedef {{}} Widget_Reply_Notice_FailedInputs */
/** @typedef {{}} Widget_Reply_Notice_NewInputs */
/** @typedef {{}} Widget_Request_Already_Sent_TitleInputs */
/** @typedef {{}} Widget_Request_BackInputs */
/** @typedef {{}} Widget_Request_Load_Failed_TextInputs */
/** @typedef {{}} Widget_Request_Load_Failed_TitleInputs */
/** @typedef {{}} Widget_Request_Loading_TextInputs */
/** @typedef {{}} Widget_Request_Loading_TitleInputs */
/** @typedef {{ id: NonNullable<unknown> }} Widget_Request_MetaInputs */
/** @typedef {{ id: NonNullable<unknown>, time: NonNullable<unknown> }} Widget_Request_Meta_TimeInputs */
/** @typedef {{}} Widget_Request_Receipt_SentInputs */
/** @typedef {{}} Widget_Request_Send_Failed_TextInputs */
/** @typedef {{}} Widget_Request_Sending_TextInputs */
/** @typedef {{}} Widget_Request_Sending_TitleInputs */
/** @typedef {{}} Widget_Request_Try_AgainInputs */
/** @typedef {{}} Widget_Resize_Height_HelpInputs */
/** @typedef {{}} Widget_Resize_Height_LabelInputs */
/** @typedef {{}} Widget_Resize_HelpInputs */
/** @typedef {{}} Widget_Resize_LabelInputs */
/** @typedef {{}} Widget_Review_Contact_EmailInputs */
/** @typedef {{}} Widget_Review_EditInputs */
/** @typedef {{}} Widget_Review_Full_RequestInputs */
/** @typedef {{}} Widget_Review_InfoInputs */
/** @typedef {{}} Widget_Review_Not_NowInputs */
/** @typedef {{}} Widget_Review_Request_TypeInputs */
/** @typedef {{}} Widget_Review_SendInputs */
/** @typedef {{}} Widget_Review_TitleInputs */
/** @typedef {{}} Widget_Review_ToInputs */
/** @typedef {{}} Widget_Seen_ClearInputs */
/** @typedef {{ title: NonNullable<unknown> }} Widget_Seen_CurrentInputs */
/** @typedef {{}} Widget_Seen_LabelInputs */
/** @typedef {{ title: NonNullable<unknown> }} Widget_Seen_MentionedInputs */
/** @typedef {{}} Widget_Select_PlaceholderInputs */
/** @typedef {{}} Widget_Sheet_CloseInputs */
/** @typedef {{ count: NonNullable<unknown> }} Widget_Shortlist_CompareInputs */
/** @typedef {{}} Widget_Shortlist_Compare_ToggleInputs */
/** @typedef {{ count: NonNullable<unknown> }} Widget_Shortlist_HiddenInputs */
/** @typedef {{ value: NonNullable<unknown>, max: NonNullable<unknown> }} Widget_Shortlist_LevelInputs */
/** @typedef {{ title: NonNullable<unknown> }} Widget_Shortlist_OpenInputs */
/** @typedef {{}} Widget_Size_HeadingInputs */
/** @typedef {{}} Widget_Size_RecommendedInputs */
/** @typedef {{}} Widget_Size_SourceInputs */
/** @typedef {{ size: NonNullable<unknown> }} Widget_Size_UsInputs */
/** @typedef {{}} Widget_Support_AvailableInputs */
/** @typedef {{}} Widget_Support_ConflictInputs */
/** @typedef {{}} Widget_Support_Copy_FailedInputs */
/** @typedef {{}} Widget_Support_Copy_SuccessInputs */
/** @typedef {{}} Widget_Support_ExpiredInputs */
/** @typedef {{}} Widget_Support_Expired_TitleInputs */
/** @typedef {{}} Widget_Support_FailedInputs */
/** @typedef {{}} Widget_Support_Field_ErrorInputs */
/** @typedef {{}} Widget_Support_InaccessibleInputs */
/** @typedef {{}} Widget_Support_LatestInputs */
/** @typedef {{}} Widget_Support_LoadingInputs */
/** @typedef {{ time: NonNullable<unknown> }} Widget_Support_Observed_AtInputs */
/** @typedef {{}} Widget_Support_Open_UnavailableInputs */
/** @typedef {{}} Widget_Support_Open_Unavailable_TitleInputs */
/** @typedef {{}} Widget_Support_Pause_FailedInputs */
/** @typedef {{}} Widget_Support_PausedInputs */
/** @typedef {{ quantity: NonNullable<unknown> }} Widget_Support_QuantityInputs */
/** @typedef {{}} Widget_Support_Rate_LimitedInputs */
/** @typedef {{}} Widget_Support_Read_FailedInputs */
/** @typedef {{ id: NonNullable<unknown> }} Widget_Support_ReferenceInputs */
/** @typedef {{}} Widget_Support_ResumeInputs */
/** @typedef {{}} Widget_Support_Resume_FailedInputs */
/** @typedef {{}} Widget_Support_RetryInputs */
/** @typedef {{}} Widget_Support_SaveInputs */
/** @typedef {{}} Widget_Support_SavedInputs */
/** @typedef {{}} Widget_Support_ScopeInputs */
/** @typedef {{}} Widget_Support_Send_FailedInputs */
/** @typedef {{}} Widget_Support_Send_Not_ConfiguredInputs */
/** @typedef {{ facts: NonNullable<unknown>, time: NonNullable<unknown> }} Widget_Support_SnapshotInputs */
/** @typedef {{}} Widget_Support_Store_UnavailableInputs */
/** @typedef {{}} Widget_Support_UnavailableInputs */
/** @typedef {{}} Widget_Support_Unavailable_TitleInputs */
/** @typedef {{}} Widget_Unavailable_Contact_PageInputs */
/** @typedef {{}} Widget_Unavailable_CopyInputs */
/** @typedef {{}} Widget_Unavailable_MessageInputs */
/** @typedef {{}} Widget_Unavailable_Other_WayInputs */
/** @typedef {{ number: NonNullable<unknown> }} Widget_Unavailable_PhoneInputs */
/** @typedef {{}} Widget_Unavailable_TitleInputs */
/** @typedef {{}} Widget_Unsent_LabelInputs */
/** @typedef {{}} Widget_Unsent_ResumeInputs */
/** @typedef {{ type: NonNullable<unknown> }} Widget_Unsent_StatusInputs */
/** @typedef {{}} Widget_Unsent_TitleInputs */
/** @typedef {{ index: NonNullable<unknown>, length: NonNullable<unknown> }} Widget_Verification_Code_DigitInputs */
/** @typedef {{}} Widget_Verification_Code_LabelInputs */
/** @typedef {{}} Widget_Verification_Request_ActionInputs */
/** @typedef {{}} Widget_Verification_Request_DescriptionInputs */
/** @typedef {{}} Widget_Verification_Request_ExpiredInputs */
/** @typedef {{}} Widget_Verification_Request_PendingInputs */
/** @typedef {{}} Widget_Verification_Request_TitleInputs */
/** @typedef {{}} Widget_Verify_Code_ExpiredInputs */
/** @typedef {{}} Widget_Verify_Code_HintInputs */
/** @typedef {{ tries: NonNullable<unknown> }} Widget_Verify_Code_WrongInputs */
/** @typedef {{}} Widget_Verify_Code_Wrong_LastInputs */
/** @typedef {{}} Widget_Verify_ConfirmInputs */
/** @typedef {{}} Widget_Verify_Contact_StoreInputs */
/** @typedef {{}} Widget_Verify_Email_ActionInputs */
/** @typedef {{}} Widget_Verify_Email_InvalidInputs */
/** @typedef {{}} Widget_Verify_Email_LabelInputs */
/** @typedef {{}} Widget_Verify_Email_PlaceholderInputs */
/** @typedef {{}} Widget_Verify_FailedInputs */
/** @typedef {{}} Widget_Verify_IntroInputs */
/** @typedef {{}} Widget_Verify_LockedInputs */
/** @typedef {{}} Widget_Verify_Playground_ActionInputs */
/** @typedef {{}} Widget_Verify_ResendInputs */
/** @typedef {{}} Widget_Verify_Resend_InInputs */
/** @typedef {{}} Widget_Verify_SendInputs */
/** @typedef {{}} Widget_Verify_SuccessInputs */
/** @typedef {{}} Widget_Verify_TitleInputs */
/** @typedef {{}} Widget_Verify_UnavailableInputs */
/** @typedef {{}} Widget_Verify_UnknownInputs */
/** @typedef {{}} Widget_Voice_AnsweringInputs */
/** @typedef {{}} Widget_Voice_ClosedInputs */
/** @typedef {{}} Widget_Voice_ConnectingInputs */
/** @typedef {{}} Widget_Voice_DisableInputs */
/** @typedef {{}} Widget_Voice_EnableInputs */
/** @typedef {{}} Widget_Voice_EndedInputs */
/** @typedef {{}} Widget_Voice_ErrorInputs */
/** @typedef {{}} Widget_Voice_ListeningInputs */
/** @typedef {{}} Widget_Voice_OccupiedInputs */
/** @typedef {{}} Widget_Voice_ReplacedInputs */
/** @typedef {{}} Widget_Voice_RevokedInputs */
/** @typedef {{}} Widget_Voice_Turn_FailedInputs */
import * as registry from "../registry.js"


export const widget_action_copied = /** @type {(inputs: Widget_Action_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copied`)
};

export const widget_bag_change = /** @type {(inputs: Widget_Bag_ChangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Change`)
};

export const widget_bag_checkout = /** @type {(inputs: Widget_Bag_CheckoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Checkout`)
};

export const widget_bag_close = /** @type {(inputs: Widget_Bag_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Close bag`)
};

export const widget_bag_decrease = /** @type {(inputs: Widget_Bag_DecreaseInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`One fewer ${i?.title}`)
};

export const widget_bag_increase = /** @type {(inputs: Widget_Bag_IncreaseInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`One more ${i?.title}`)
};

export const widget_bag_label = /** @type {(inputs: Widget_Bag_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bag`)
};

export const widget_bag_open = /** @type {(inputs: Widget_Bag_OpenInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Open your bag, ${i?.count} items`)
};

export const widget_bag_remove = /** @type {(inputs: Widget_Bag_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remove`)
};

export const widget_bag_savings = /** @type {(inputs: Widget_Bag_SavingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Savings`)
};

export const widget_bag_shipping = /** @type {(inputs: Widget_Bag_ShippingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Shipping & taxes`)
};

export const widget_bag_shipping_value = /** @type {(inputs: Widget_Bag_Shipping_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculated at checkout`)
};

export const widget_bag_subtotal = /** @type {(inputs: Widget_Bag_SubtotalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subtotal`)
};

export const widget_bag_synced = /** @type {(inputs: Widget_Bag_SyncedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Synced with your store bag · Payment on Shopify`)
};

export const widget_bag_title = /** @type {(inputs: Widget_Bag_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your bag`)
};

export const widget_bag_total = /** @type {(inputs: Widget_Bag_TotalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Total`)
};

export const widget_blocks_loading = /** @type {(inputs: Widget_Blocks_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Loading details…`)
};

export const widget_blocks_pending = /** @type {(inputs: Widget_Blocks_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Details are currently unavailable.`)
};

export const widget_blocks_refresh_failed = /** @type {(inputs: Widget_Blocks_Refresh_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Details could not be refreshed. Your form is kept; try again shortly.`)
};

export const widget_board_open = /** @type {(inputs: Widget_Board_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open`)
};

export const widget_board_showing = /** @type {(inputs: Widget_Board_ShowingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`On the board`)
};

export const widget_cart_add_failed = /** @type {(inputs: Widget_Cart_Add_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Couldn’t add to cart. Your choices are kept.`)
};

export const widget_cart_add_total = /** @type {(inputs: Widget_Cart_Add_TotalInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Add to cart · ${i?.total}`)
};

export const widget_cart_adding = /** @type {(inputs: Widget_Cart_AddingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adding to your Shopify cart…`)
};

export const widget_cart_adding_short = /** @type {(inputs: Widget_Cart_Adding_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adding…`)
};

export const widget_cart_all_in_cart = /** @type {(inputs: Widget_Cart_All_In_CartInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("en", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`The only one available is in your cart`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`All ${i?.count} available are in your cart`);
	return /** @type {LocalizedString} */ ("widget_cart_all_in_cart");
};

export const widget_cart_available = /** @type {(inputs: Widget_Cart_AvailableInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Only ${i?.count} available`)
};

export const widget_cart_change_failed = /** @type {(inputs: Widget_Cart_Change_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Couldn’t change it to ${i?.to}. Your cart still has ${i?.from}.`)
};

export const widget_cart_change_unconfirmed = /** @type {(inputs: Widget_Cart_Change_UnconfirmedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Couldn’t confirm the change. Try again.`)
};

export const widget_cart_changes = /** @type {(inputs: Widget_Cart_ChangesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Changes ${i?.from} to ${i?.to} in your Shopify cart`)
};

export const widget_cart_check_again = /** @type {(inputs: Widget_Cart_Check_AgainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Check again`)
};

export const widget_cart_checking = /** @type {(inputs: Widget_Cart_CheckingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Checking your cart…`)
};

export const widget_cart_checking_short = /** @type {(inputs: Widget_Cart_Checking_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Checking…`)
};

export const widget_cart_clamp_available = /** @type {(inputs: Widget_Cart_Clamp_AvailableInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Changed to ${i?.count}. Only ${i?.available} available.`)
};

export const widget_cart_clamp_in_cart = /** @type {(inputs: Widget_Cart_Clamp_In_CartInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Changed to ${i?.count}. ${i?.inCart} already in your cart.`)
};

export const widget_cart_decrease = /** @type {(inputs: Widget_Cart_DecreaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Decrease quantity`)
};

export const widget_cart_edit_title = /** @type {(inputs: Widget_Cart_Edit_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Edit quantity`)
};

export const widget_cart_enter_quantity = /** @type {(inputs: Widget_Cart_Enter_QuantityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter a quantity of 1 or more`)
};

export const widget_cart_in_cart = /** @type {(inputs: Widget_Cart_In_CartInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} in cart`)
};

export const widget_cart_increase = /** @type {(inputs: Widget_Cart_IncreaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Increase quantity`)
};

export const widget_cart_lowest = /** @type {(inputs: Widget_Cart_LowestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The lowest quantity is 1.`)
};

export const widget_cart_missing = /** @type {(inputs: Widget_Cart_MissingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This item is no longer in your cart.`)
};

export const widget_cart_new_quantity = /** @type {(inputs: Widget_Cart_New_QuantityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New quantity`)
};

export const widget_cart_now_in_cart = /** @type {(inputs: Widget_Cart_Now_In_CartInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`In cart: ${i?.count}`)
};

export const widget_cart_option_heading = /** @type {(inputs: Widget_Cart_Option_HeadingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} · ${i?.value}`)
};

export const widget_cart_quantity = /** @type {(inputs: Widget_Cart_QuantityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quantity`)
};

export const widget_cart_read_failed = /** @type {(inputs: Widget_Cart_Read_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Couldn’t check your cart right now.`)
};

export const widget_cart_receipt_added = /** @type {(inputs: Widget_Cart_Receipt_AddedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Added to cart`)
};

export const widget_cart_receipt_merged = /** @type {(inputs: Widget_Cart_Receipt_MergedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.added} added just now · ${i?.count} in your cart`)
};

export const widget_cart_receipt_partial = /** @type {(inputs: Widget_Cart_Receipt_PartialInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Added ${i?.added} of ${i?.requested}`)
};

export const widget_cart_receipt_qty = /** @type {(inputs: Widget_Cart_Receipt_QtyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Qty ${i?.count}`)
};

export const widget_cart_receipt_short = /** @type {(inputs: Widget_Cart_Receipt_ShortInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`You asked for ${i?.requested}. Only ${i?.count} available, so your cart has ${i?.count}.`)
};

export const widget_cart_receipt_short_more = /** @type {(inputs: Widget_Cart_Receipt_Short_MoreInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`You asked for ${i?.requested} more. Only ${i?.count} available in total, so your cart has ${i?.count}.`)
};

export const widget_cart_receipt_updated = /** @type {(inputs: Widget_Cart_Receipt_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quantity updated`)
};

export const widget_cart_rejected = /** @type {(inputs: Widget_Cart_RejectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Shopify didn’t accept this quantity.`)
};

export const widget_cart_retry = /** @type {(inputs: Widget_Cart_RetryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Retry`)
};

export const widget_cart_retry_set = /** @type {(inputs: Widget_Cart_Retry_SetInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Retry · set to ${i?.count}`)
};

export const widget_cart_select = /** @type {(inputs: Widget_Cart_SelectInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Select ${i?.options}`)
};

export const widget_cart_summary = /** @type {(inputs: Widget_Cart_SummaryInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.variant} · Qty ${i?.count}`)
};

export const widget_cart_summary_default = /** @type {(inputs: Widget_Cart_Summary_DefaultInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Qty ${i?.count}`)
};

export const widget_cart_unchanged = /** @type {(inputs: Widget_Cart_UnchangedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Change the number to update your cart`)
};

export const widget_cart_unconfirmed = /** @type {(inputs: Widget_Cart_UnconfirmedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Couldn’t confirm. Check your cart so nothing is added twice.`)
};

export const widget_cart_update = /** @type {(inputs: Widget_Cart_UpdateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Update quantity`)
};

export const widget_cart_updating = /** @type {(inputs: Widget_Cart_UpdatingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Updating your Shopify cart…`)
};

export const widget_cart_updating_short = /** @type {(inputs: Widget_Cart_Updating_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Updating…`)
};

export const widget_cart_value_sold_out = /** @type {(inputs: Widget_Cart_Value_Sold_OutInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.value}, sold out`)
};

export const widget_cart_variant_sold_out = /** @type {(inputs: Widget_Cart_Variant_Sold_OutInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.variant} is sold out`)
};

export const widget_compare_add_row = /** @type {(inputs: Widget_Compare_Add_RowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add to bag`)
};

export const widget_compare_asked = /** @type {(inputs: Widget_Compare_AskedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You asked about this`)
};

export const widget_compare_caption = /** @type {(inputs: Widget_Compare_CaptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Comparison of ${i?.first} and ${i?.second}`)
};

export const widget_compare_differs = /** @type {(inputs: Widget_Compare_DiffersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Different`)
};

export const widget_compare_field = /** @type {(inputs: Widget_Compare_FieldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Detail`)
};

export const widget_composer_busy = /** @type {(inputs: Widget_Composer_BusyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Looking through the store…`)
};

export const widget_composer_placeholder = /** @type {(inputs: Widget_Composer_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ask a question…`)
};

export const widget_composer_send = /** @type {(inputs: Widget_Composer_SendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Send`)
};

export const widget_contact_description_error = /** @type {(inputs: Widget_Contact_Description_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tell the store what you need help with.`)
};

export const widget_contact_description_hint = /** @type {(inputs: Widget_Contact_Description_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We filled this in from your chat. You can edit it.`)
};

export const widget_contact_description_label = /** @type {(inputs: Widget_Contact_Description_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What would you like help with?`)
};

export const widget_contact_description_placeholder = /** @type {(inputs: Widget_Contact_Description_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tell the store what you need…`)
};

export const widget_contact_dismiss = /** @type {(inputs: Widget_Contact_DismissInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Not now`)
};

export const widget_contact_email_error_empty = /** @type {(inputs: Widget_Contact_Email_Error_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter your email so the store can reply.`)
};

export const widget_contact_email_error_format = /** @type {(inputs: Widget_Contact_Email_Error_FormatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter a full email address, like name@example.com.`)
};

export const widget_contact_email_error_own = /** @type {(inputs: Widget_Contact_Email_Error_OwnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Use your own email. This is the store’s address, so replies wouldn’t reach you.`)
};

export const widget_contact_email_from = /** @type {(inputs: Widget_Contact_Email_FromInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`From`)
};

export const widget_contact_email_hint_account = /** @type {(inputs: Widget_Contact_Email_Hint_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`From your store account`)
};

export const widget_contact_email_hint_checkout = /** @type {(inputs: Widget_Contact_Email_Hint_CheckoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`From your verified checkout email`)
};

export const widget_contact_email_label = /** @type {(inputs: Widget_Contact_Email_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your contact email`)
};

export const widget_contact_email_placeholder = /** @type {(inputs: Widget_Contact_Email_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`you@example.com`)
};

export const widget_contact_email_preview_label = /** @type {(inputs: Widget_Contact_Email_Preview_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Email preview`)
};

export const widget_contact_email_reply_to = /** @type {(inputs: Widget_Contact_Email_Reply_ToInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reply-to`)
};

export const widget_contact_email_subject = /** @type {(inputs: Widget_Contact_Email_SubjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subject`)
};

export const widget_contact_email_to = /** @type {(inputs: Widget_Contact_Email_ToInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`To`)
};

export const widget_contact_optional = /** @type {(inputs: Widget_Contact_OptionalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`(optional)`)
};

export const widget_contact_order_hint_unverified = /** @type {(inputs: Widget_Contact_Order_Hint_UnverifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Not verified — the store will check it`)
};

export const widget_contact_order_hint_verified = /** @type {(inputs: Widget_Contact_Order_Hint_VerifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verified with your checkout email`)
};

export const widget_contact_order_label = /** @type {(inputs: Widget_Contact_Order_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Order reference`)
};

export const widget_contact_order_placeholder = /** @type {(inputs: Widget_Contact_Order_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#1234`)
};

export const widget_contact_order_verified = /** @type {(inputs: Widget_Contact_Order_VerifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verified`)
};

export const widget_contact_product_view = /** @type {(inputs: Widget_Contact_Product_ViewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`View product`)
};

export const widget_contact_products_as_of = /** @type {(inputs: Widget_Contact_Products_As_OfInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Price and stock as of ${i?.time}`)
};

export const widget_contact_products_legend = /** @type {(inputs: Widget_Contact_Products_LegendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Related products`)
};

export const widget_contact_recipient_label = /** @type {(inputs: Widget_Contact_Recipient_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`To · Store`)
};

export const widget_contact_reply_note = /** @type {(inputs: Widget_Contact_Reply_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The store will reply to your request by email.`)
};

export const widget_contact_request_type = /** @type {(inputs: Widget_Contact_Request_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Request type`)
};

export const widget_contact_review = /** @type {(inputs: Widget_Contact_ReviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Review request`)
};

export const widget_contact_send = /** @type {(inputs: Widget_Contact_SendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Send request`)
};

export const widget_contact_title = /** @type {(inputs: Widget_Contact_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How can the store help?`)
};

export const widget_contact_type_delivery_issues = /** @type {(inputs: Widget_Contact_Type_Delivery_IssuesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delivery issues`)
};

export const widget_contact_type_order_cancellation = /** @type {(inputs: Widget_Contact_Type_Order_CancellationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Order cancellation`)
};

export const widget_contact_type_order_changes = /** @type {(inputs: Widget_Contact_Type_Order_ChangesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Order changes`)
};

export const widget_contact_type_order_status = /** @type {(inputs: Widget_Contact_Type_Order_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Order status and tracking`)
};

export const widget_contact_type_other = /** @type {(inputs: Widget_Contact_Type_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Other requests and contact support`)
};

export const widget_contact_type_product_issues = /** @type {(inputs: Widget_Contact_Type_Product_IssuesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Product issues and warranty`)
};

export const widget_contact_type_returns = /** @type {(inputs: Widget_Contact_Type_ReturnsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Returns, exchanges and refunds`)
};

export const widget_contact_type_subscriptions = /** @type {(inputs: Widget_Contact_Type_SubscriptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Product subscriptions`)
};

export const widget_conversation_latest = /** @type {(inputs: Widget_Conversation_LatestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Back to latest`)
};

export const widget_conversation_messages = /** @type {(inputs: Widget_Conversation_MessagesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Messages`)
};

export const widget_drawer_resize = /** @type {(inputs: Widget_Drawer_ResizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resize chat`)
};

export const widget_email_result_accepted_fact = /** @type {(inputs: Widget_Email_Result_Accepted_FactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accepted for sending`)
};

export const widget_email_result_check = /** @type {(inputs: Widget_Email_Result_CheckInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Check original email`)
};

export const widget_email_result_edit = /** @type {(inputs: Widget_Email_Result_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Edit request`)
};

export const widget_email_result_email = /** @type {(inputs: Widget_Email_Result_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your email`)
};

export const widget_email_result_group = /** @type {(inputs: Widget_Email_Result_GroupInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Request ${i?.id}`)
};

export const widget_email_result_next = /** @type {(inputs: Widget_Email_Result_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Next`)
};

export const widget_email_result_next_bounced = /** @type {(inputs: Widget_Email_Result_Next_BouncedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The store’s inbox didn’t accept this email. Sending was accepted, but delivery failed. Contact the store through its published contact channels.`)
};

export const widget_email_result_next_failed = /** @type {(inputs: Widget_Email_Result_Next_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your details are saved. Try sending again.`)
};

export const widget_email_result_next_reply = /** @type {(inputs: Widget_Email_Result_Next_ReplyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`The store will reply to ${i?.email} by email.`)
};

export const widget_email_result_next_sending = /** @type {(inputs: Widget_Email_Result_Next_SendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We’ll show the result here in a moment.`)
};

export const widget_email_result_next_unknown = /** @type {(inputs: Widget_Email_Result_Next_UnknownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We’re checking the original email. Delivery is not confirmed. Check its status without sending it again.`)
};

export const widget_email_result_request = /** @type {(inputs: Widget_Email_Result_RequestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Request`)
};

export const widget_email_result_retry = /** @type {(inputs: Widget_Email_Result_RetryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Retry`)
};

export const widget_email_result_sending_action = /** @type {(inputs: Widget_Email_Result_Sending_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sending request`)
};

export const widget_email_result_start_new = /** @type {(inputs: Widget_Email_Result_Start_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start a new request`)
};

export const widget_email_result_submitted = /** @type {(inputs: Widget_Email_Result_SubmittedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Submitted`)
};

export const widget_email_result_subtitle_accepted = /** @type {(inputs: Widget_Email_Result_Subtitle_AcceptedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delivery is not yet confirmed`)
};

export const widget_email_result_title_accepted = /** @type {(inputs: Widget_Email_Result_Title_AcceptedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Request sent`)
};

export const widget_email_result_title_bounced = /** @type {(inputs: Widget_Email_Result_Title_BouncedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We couldn’t deliver your request to the store`)
};

export const widget_email_result_title_delivered = /** @type {(inputs: Widget_Email_Result_Title_DeliveredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Email delivered`)
};

export const widget_email_result_title_failed = /** @type {(inputs: Widget_Email_Result_Title_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We couldn’t send your request`)
};

export const widget_email_result_title_sending = /** @type {(inputs: Widget_Email_Result_Title_SendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sending request`)
};

export const widget_email_result_title_unknown = /** @type {(inputs: Widget_Email_Result_Title_UnknownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Checking email status`)
};

export const widget_email_result_to = /** @type {(inputs: Widget_Email_Result_ToInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`To`)
};

export const widget_email_result_updated = /** @type {(inputs: Widget_Email_Result_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Updated`)
};

export const widget_empty_title = /** @type {(inputs: Widget_Empty_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How can I help today?`)
};

export const widget_error_answer_lost = /** @type {(inputs: Widget_Error_Answer_LostInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The previous answer could not be restored. Your message is kept below; send it again to retry.`)
};

export const widget_error_chat_unavailable = /** @type {(inputs: Widget_Error_Chat_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chat is unavailable.`)
};

export const widget_error_no_answer = /** @type {(inputs: Widget_Error_No_AnswerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chat is unavailable. Your message is kept below; send it again to retry.`)
};

export const widget_error_playground_expired = /** @type {(inputs: Widget_Error_Playground_ExpiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This Playground session expired and could not be refreshed. Reload the page, then open the app from Shopify again if it keeps happening.`)
};

export const widget_error_signin_unavailable = /** @type {(inputs: Widget_Error_Signin_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sign-in isn't available right now. You can keep chatting as a guest.`)
};

export const widget_evidence_sold_out = /** @type {(inputs: Widget_Evidence_Sold_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sold out`)
};

export const widget_evidence_store_page = /** @type {(inputs: Widget_Evidence_Store_PageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`View on the store page`)
};

export const widget_feedback_cancel = /** @type {(inputs: Widget_Feedback_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancel`)
};

export const widget_feedback_default = /** @type {(inputs: Widget_Feedback_DefaultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Feedback`)
};

export const widget_feedback_details_placeholder = /** @type {(inputs: Widget_Feedback_Details_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Describe the issue and a better approach. Leave out personal information.`)
};

export const widget_feedback_help = /** @type {(inputs: Widget_Feedback_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your feedback will help GoNovus team to improve AI responses`)
};

export const widget_feedback_label = /** @type {(inputs: Widget_Feedback_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Message feedback`)
};

export const widget_feedback_load_failed = /** @type {(inputs: Widget_Feedback_Load_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Couldn't load feedback reasons.`)
};

export const widget_feedback_loading = /** @type {(inputs: Widget_Feedback_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Loading reasons…`)
};

export const widget_feedback_network_failed = /** @type {(inputs: Widget_Feedback_Network_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Network error. Check your connection and try again.`)
};

export const widget_feedback_send = /** @type {(inputs: Widget_Feedback_SendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Send feedback`)
};

export const widget_feedback_send_failed = /** @type {(inputs: Widget_Feedback_Send_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Couldn't send this feedback. Try again.`)
};

export const widget_feedback_submitted = /** @type {(inputs: Widget_Feedback_SubmittedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Submitted`)
};

export const widget_feedback_submitted_by = /** @type {(inputs: Widget_Feedback_Submitted_ByInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Submitted by ${i?.memberName}`)
};

export const widget_feedback_title = /** @type {(inputs: Widget_Feedback_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What went wrong?`)
};

export const widget_footer_powered_by = /** @type {(inputs: Widget_Footer_Powered_ByInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Powered by GoNovus`)
};

export const widget_form_dismiss = /** @type {(inputs: Widget_Form_DismissInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dismiss`)
};

export const widget_generating_catalog = /** @type {(inputs: Widget_Generating_CatalogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Flipping through the catalog…`)
};

export const widget_generating_deals = /** @type {(inputs: Widget_Generating_DealsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sniffing out deals…`)
};

export const widget_generating_details = /** @type {(inputs: Widget_Generating_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Double-checking the details…`)
};

export const widget_generating_racks = /** @type {(inputs: Widget_Generating_RacksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rummaging through the racks…`)
};

export const widget_generating_shelves = /** @type {(inputs: Widget_Generating_ShelvesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Browsing the shelves…`)
};

export const widget_generating_still = /** @type {(inputs: Widget_Generating_StillInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Still on it…`)
};

export const widget_generating_stockroom = /** @type {(inputs: Widget_Generating_StockroomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Peeking in the stockroom…`)
};

export const widget_header_clear = /** @type {(inputs: Widget_Header_ClearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clear conversation`)
};

export const widget_header_close = /** @type {(inputs: Widget_Header_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Close chat`)
};

export const widget_header_enter_fullscreen = /** @type {(inputs: Widget_Header_Enter_FullscreenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter full screen`)
};

export const widget_header_enter_space = /** @type {(inputs: Widget_Header_Enter_SpaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open your space`)
};

export const widget_header_exit_fullscreen = /** @type {(inputs: Widget_Header_Exit_FullscreenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exit full screen`)
};

export const widget_header_exit_space = /** @type {(inputs: Widget_Header_Exit_SpaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Back to chat window`)
};

export const widget_header_minimize = /** @type {(inputs: Widget_Header_MinimizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minimize`)
};

export const widget_header_status = /** @type {(inputs: Widget_Header_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Replies instantly`)
};

export const widget_header_title = /** @type {(inputs: Widget_Header_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Shopping assistant`)
};

export const widget_launcher_label = /** @type {(inputs: Widget_Launcher_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chat`)
};

export const widget_loading_chat = /** @type {(inputs: Widget_Loading_ChatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opening chat…`)
};

export const widget_look_in_bag = /** @type {(inputs: Widget_Look_In_BagInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`In your bag · ${i?.variant}`)
};

export const widget_look_position = /** @type {(inputs: Widget_Look_PositionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.label} · ${i?.index} of ${i?.total}`)
};

export const widget_look_selected = /** @type {(inputs: Widget_Look_SelectedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Selected · ${i?.variant}`)
};

export const widget_look_swap = /** @type {(inputs: Widget_Look_SwapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Swap`)
};

export const widget_look_swap_label = /** @type {(inputs: Widget_Look_Swap_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Swap the ${i?.role}`)
};

export const widget_message_copy = /** @type {(inputs: Widget_Message_CopyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copy message`)
};

export const widget_message_dislike = /** @type {(inputs: Widget_Message_DislikeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Not helpful`)
};

export const widget_message_feedback_sorry = /** @type {(inputs: Widget_Message_Feedback_SorryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We’ll do better`)
};

export const widget_message_feedback_thanks = /** @type {(inputs: Widget_Message_Feedback_ThanksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thanks for the feedback`)
};

export const widget_message_image = /** @type {(inputs: Widget_Message_ImageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Image from the store`)
};

export const widget_message_image_close = /** @type {(inputs: Widget_Message_Image_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Close image`)
};

export const widget_message_image_open = /** @type {(inputs: Widget_Message_Image_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enlarge image`)
};

export const widget_message_image_unavailable = /** @type {(inputs: Widget_Message_Image_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This image could not be loaded.`)
};

export const widget_message_like = /** @type {(inputs: Widget_Message_LikeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Helpful`)
};

export const widget_message_replying = /** @type {(inputs: Widget_Message_ReplyingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Replying`)
};

export const widget_message_retry = /** @type {(inputs: Widget_Message_RetryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Retry`)
};

export const widget_message_undelivered = /** @type {(inputs: Widget_Message_UndeliveredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Not delivered`)
};

export const widget_message_unsupported = /** @type {(inputs: Widget_Message_UnsupportedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This part of the message cannot be displayed.`)
};

export const widget_notice_now_viewing = /** @type {(inputs: Widget_Notice_Now_ViewingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Now viewing · ${i?.title}`)
};

export const widget_order_adjustments = /** @type {(inputs: Widget_Order_AdjustmentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancellation, returns and refunds`)
};

export const widget_order_canceled_items = /** @type {(inputs: Widget_Order_Canceled_ItemsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Canceled`)
};

export const widget_order_cancellation = /** @type {(inputs: Widget_Order_CancellationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Order canceled`)
};

export const widget_order_carrier_unknown = /** @type {(inputs: Widget_Order_Carrier_UnknownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carrier not provided`)
};

export const widget_order_check_action = /** @type {(inputs: Widget_Order_Check_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Check my order`)
};

export const widget_order_contact = /** @type {(inputs: Widget_Order_ContactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contact store`)
};

export const widget_order_details_label = /** @type {(inputs: Widget_Order_Details_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Order details`)
};

export const widget_order_empty_title = /** @type {(inputs: Widget_Order_Empty_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No readable orders found`)
};

export const widget_order_error_inaccessible = /** @type {(inputs: Widget_Order_Error_InaccessibleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`These order details are unavailable.`)
};

export const widget_order_error_offline = /** @type {(inputs: Widget_Order_Error_OfflineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Order details are currently unavailable.`)
};

export const widget_order_error_rate_limited = /** @type {(inputs: Widget_Order_Error_Rate_LimitedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Order details are currently unavailable.`)
};

export const widget_order_error_upstream = /** @type {(inputs: Widget_Order_Error_UpstreamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Order details are currently unavailable.`)
};

export const widget_order_error_verification = /** @type {(inputs: Widget_Order_Error_VerificationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verify your identity to view order details.`)
};

export const widget_order_eta_source = /** @type {(inputs: Widget_Order_Eta_SourceInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Source estimate: ${i?.time}`)
};

export const widget_order_eta_unknown = /** @type {(inputs: Widget_Order_Eta_UnknownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delivery estimate not provided`)
};

export const widget_order_event_waiting = /** @type {(inputs: Widget_Order_Event_WaitingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Checking your order…`)
};

export const widget_order_eyebrow = /** @type {(inputs: Widget_Order_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Order`)
};

export const widget_order_failed_title = /** @type {(inputs: Widget_Order_Failed_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We couldn’t load your orders`)
};

export const widget_order_fulfilled_items = /** @type {(inputs: Widget_Order_Fulfilled_ItemsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fulfilled items`)
};

export const widget_order_hidden_title = /** @type {(inputs: Widget_Order_Hidden_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Order details hidden`)
};

export const widget_order_item_quantity = /** @type {(inputs: Widget_Order_Item_QuantityInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Qty ${i?.count}`)
};

export const widget_order_label_created = /** @type {(inputs: Widget_Order_Label_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Label created — carrier pickup not confirmed`)
};

export const widget_order_loading = /** @type {(inputs: Widget_Order_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Loading your order…`)
};

export const widget_order_more_fulfillments = /** @type {(inputs: Widget_Order_More_FulfillmentsInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("en", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.count} more fulfillment record not shown`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`${i?.count} more fulfillment records not shown`);
	return /** @type {LocalizedString} */ ("widget_order_more_fulfillments");
};

export const widget_order_more_refunds = /** @type {(inputs: Widget_Order_More_RefundsInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("en", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.count} more refund record not shown`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`${i?.count} more refund records not shown`);
	return /** @type {LocalizedString} */ ("widget_order_more_refunds");
};

export const widget_order_more_returns = /** @type {(inputs: Widget_Order_More_ReturnsInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("en", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.count} more return not shown`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`${i?.count} more returns not shown`);
	return /** @type {LocalizedString} */ ("widget_order_more_returns");
};

export const widget_order_more_trackings = /** @type {(inputs: Widget_Order_More_TrackingsInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("en", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.count} more tracking number not shown`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`${i?.count} more tracking numbers not shown`);
	return /** @type {LocalizedString} */ ("widget_order_more_trackings");
};

export const widget_order_no_shipping = /** @type {(inputs: Widget_Order_No_ShippingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No shipping required`)
};

export const widget_order_not_received = /** @type {(inputs: Widget_Order_Not_ReceivedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I haven’t received this`)
};

export const widget_order_payment = /** @type {(inputs: Widget_Order_PaymentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Payment`)
};

export const widget_order_payment_authorized = /** @type {(inputs: Widget_Order_Payment_AuthorizedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Authorized`)
};

export const widget_order_payment_paid = /** @type {(inputs: Widget_Order_Payment_PaidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paid`)
};

export const widget_order_payment_partially_paid = /** @type {(inputs: Widget_Order_Payment_Partially_PaidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Partially paid`)
};

export const widget_order_payment_partially_refunded = /** @type {(inputs: Widget_Order_Payment_Partially_RefundedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Partially refunded`)
};

export const widget_order_payment_pending = /** @type {(inputs: Widget_Order_Payment_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Payment pending`)
};

export const widget_order_payment_refunded = /** @type {(inputs: Widget_Order_Payment_RefundedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Refunded`)
};

export const widget_order_payment_voided = /** @type {(inputs: Widget_Order_Payment_VoidedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voided`)
};

export const widget_order_pending_items = /** @type {(inputs: Widget_Order_Pending_ItemsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Awaiting fulfillment`)
};

export const widget_order_progress_label = /** @type {(inputs: Widget_Order_Progress_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Order progress`)
};

export const widget_order_refund_record = /** @type {(inputs: Widget_Order_Refund_RecordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Refund record`)
};

export const widget_order_retry = /** @type {(inputs: Widget_Order_RetryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Retry`)
};

export const widget_order_return_record = /** @type {(inputs: Widget_Order_Return_RecordInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Return ${i?.name}`)
};

export const widget_order_ship_to = /** @type {(inputs: Widget_Order_Ship_ToInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ship to`)
};

export const widget_order_shipped_items = /** @type {(inputs: Widget_Order_Shipped_ItemsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Shipped items`)
};

export const widget_order_shipping_unknown = /** @type {(inputs: Widget_Order_Shipping_UnknownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Items`)
};

export const widget_order_status = /** @type {(inputs: Widget_Order_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Status`)
};

export const widget_order_status_canceled = /** @type {(inputs: Widget_Order_Status_CanceledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Canceled`)
};

export const widget_order_status_delivered = /** @type {(inputs: Widget_Order_Status_DeliveredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delivered`)
};

export const widget_order_status_partially_shipped = /** @type {(inputs: Widget_Order_Status_Partially_ShippedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Partially shipped`)
};

export const widget_order_status_shipped = /** @type {(inputs: Widget_Order_Status_ShippedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Shipped`)
};

export const widget_order_status_unfulfilled = /** @type {(inputs: Widget_Order_Status_UnfulfilledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unfulfilled`)
};

export const widget_order_step_arrives = /** @type {(inputs: Widget_Order_Step_ArrivesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Arrives`)
};

export const widget_order_step_delivered = /** @type {(inputs: Widget_Order_Step_DeliveredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delivered`)
};

export const widget_order_step_placed = /** @type {(inputs: Widget_Order_Step_PlacedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Placed`)
};

export const widget_order_step_shipped = /** @type {(inputs: Widget_Order_Step_ShippedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Shipped`)
};

export const widget_order_total = /** @type {(inputs: Widget_Order_TotalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Total`)
};

export const widget_order_track = /** @type {(inputs: Widget_Order_TrackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Track shipment`)
};

export const widget_order_unavailable_title = /** @type {(inputs: Widget_Order_Unavailable_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Order details unavailable`)
};

export const widget_order_unknown = /** @type {(inputs: Widget_Order_UnknownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Not provided`)
};

export const widget_order_verified = /** @type {(inputs: Widget_Order_VerifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verification complete.`)
};

export const widget_order_verified_detail = /** @type {(inputs: Widget_Order_Verified_DetailInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Showing orders for ${i?.email}.`)
};

export const widget_order_view = /** @type {(inputs: Widget_Order_ViewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`View order`)
};

export const widget_orders_limit_reached = /** @type {(inputs: Widget_Orders_Limit_ReachedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`To find more orders, ask with your order number.`)
};

export const widget_orders_list_label = /** @type {(inputs: Widget_Orders_List_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Orders, newest first`)
};

export const widget_orders_load_more = /** @type {(inputs: Widget_Orders_Load_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Load more`)
};

export const widget_orders_loading = /** @type {(inputs: Widget_Orders_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Loading…`)
};

export const widget_orders_loading_first = /** @type {(inputs: Widget_Orders_Loading_FirstInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Loading your orders…`)
};

export const widget_orders_loading_status = /** @type {(inputs: Widget_Orders_Loading_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Loading more orders…`)
};

export const widget_orders_more_items = /** @type {(inputs: Widget_Orders_More_ItemsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`+ ${i?.count} more`)
};

export const widget_orders_newest_first = /** @type {(inputs: Widget_Orders_Newest_FirstInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Newest first`)
};

export const widget_orders_order_number = /** @type {(inputs: Widget_Orders_Order_NumberInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Order ${i?.number}`)
};

export const widget_orders_readable_empty = /** @type {(inputs: Widget_Orders_Readable_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No more orders are readable from this account. You can contact the store for help.`)
};

export const widget_orders_show_more = /** @type {(inputs: Widget_Orders_Show_MoreInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Show ${i?.count} more`)
};

export const widget_orders_title = /** @type {(inputs: Widget_Orders_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your orders`)
};

export const widget_peek_open = /** @type {(inputs: Widget_Peek_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open chat`)
};

export const widget_picker_confirm = /** @type {(inputs: Widget_Picker_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Use this element?`)
};

export const widget_picker_consumed = /** @type {(inputs: Widget_Picker_ConsumedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This pick link was already used or expired. Go back to the app admin to check the rule.`)
};

export const widget_picker_exit = /** @type {(inputs: Widget_Picker_ExitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exit element picker`)
};

export const widget_picker_failed = /** @type {(inputs: Widget_Picker_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Could not save. Try again.`)
};

export const widget_picker_for_rule = /** @type {(inputs: Widget_Picker_For_RuleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`For rule: ${i?.prompt}`)
};

export const widget_picker_hint = /** @type {(inputs: Widget_Picker_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hover to highlight an element, press Enter to select it. Esc exits.`)
};

export const widget_picker_invalid = /** @type {(inputs: Widget_Picker_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This pick link is invalid or expired. Open it again from the app admin.`)
};

export const widget_picker_region = /** @type {(inputs: Widget_Picker_RegionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Element picker`)
};

export const widget_picker_reselect = /** @type {(inputs: Widget_Picker_ReselectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pick again`)
};

export const widget_picker_retry = /** @type {(inputs: Widget_Picker_RetryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Retry`)
};

export const widget_picker_rule_gone = /** @type {(inputs: Widget_Picker_Rule_GoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This rule was removed or changed. Go back to the app admin.`)
};

export const widget_picker_save = /** @type {(inputs: Widget_Picker_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Save & return`)
};

export const widget_picker_saving = /** @type {(inputs: Widget_Picker_SavingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saving…`)
};

export const widget_picker_selector_rejected = /** @type {(inputs: Widget_Picker_Selector_RejectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`That element can’t be used. Pick a different one.`)
};

export const widget_playground_customer_action = /** @type {(inputs: Widget_Playground_Customer_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Test as this customer`)
};

export const widget_playground_customer_description = /** @type {(inputs: Widget_Playground_Customer_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Playground has no store sign-in. Enter the email of a customer in your store to test as that customer.`)
};

export const widget_playground_customer_email_label = /** @type {(inputs: Widget_Playground_Customer_Email_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Customer email`)
};

export const widget_playground_customer_not_found = /** @type {(inputs: Widget_Playground_Customer_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No customer in your store uses this email.`)
};

export const widget_preview_proactive = /** @type {(inputs: Widget_Preview_ProactiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Need a hand finding your size?`)
};

export const widget_preview_product_title = /** @type {(inputs: Widget_Preview_Product_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Classic Linen Shirt`)
};

export const widget_proactive_dismiss = /** @type {(inputs: Widget_Proactive_DismissInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dismiss suggestion`)
};

export const widget_product_add = /** @type {(inputs: Widget_Product_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add to cart`)
};

export const widget_product_cart = /** @type {(inputs: Widget_Product_CartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`View cart`)
};

export const widget_product_load_failed = /** @type {(inputs: Widget_Product_Load_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unable to check availability. Please open the product page.`)
};

export const widget_product_opening = /** @type {(inputs: Widget_Product_OpeningInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.price} · Opening…`)
};

export const widget_product_sold_out = /** @type {(inputs: Widget_Product_Sold_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sold out`)
};

export const widget_product_subscription = /** @type {(inputs: Widget_Product_SubscriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subscription only`)
};

export const widget_replay_handed_off = /** @type {(inputs: Widget_Replay_Handed_OffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Handed off`)
};

export const widget_reply_card_currency = /** @type {(inputs: Widget_Reply_Card_CurrencyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Currency`)
};

export const widget_reply_card_details = /** @type {(inputs: Widget_Reply_Card_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Details`)
};

export const widget_reply_card_expired = /** @type {(inputs: Widget_Reply_Card_ExpiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Expired`)
};

export const widget_reply_card_generic = /** @type {(inputs: Widget_Reply_Card_GenericInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Attachment`)
};

export const widget_reply_card_missing_fields = /** @type {(inputs: Widget_Reply_Card_Missing_FieldsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Some order details are unavailable.`)
};

export const widget_reply_card_notice = /** @type {(inputs: Widget_Reply_Card_NoticeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notice`)
};

export const widget_reply_card_order_detail = /** @type {(inputs: Widget_Reply_Card_Order_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Order`)
};

export const widget_reply_card_order_list = /** @type {(inputs: Widget_Reply_Card_Order_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Orders`)
};

export const widget_reply_card_quick_action = /** @type {(inputs: Widget_Reply_Card_Quick_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quick action`)
};

export const widget_reply_card_revoked = /** @type {(inputs: Widget_Reply_Card_RevokedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Revoked`)
};

export const widget_reply_card_support_request = /** @type {(inputs: Widget_Reply_Card_Support_RequestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Support request`)
};

export const widget_reply_card_verification = /** @type {(inputs: Widget_Reply_Card_VerificationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verification`)
};

export const widget_reply_empty = /** @type {(inputs: Widget_Reply_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I couldn’t answer that. Please contact the store for help.`)
};

export const widget_reply_notice_dismiss = /** @type {(inputs: Widget_Reply_Notice_DismissInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dismiss`)
};

export const widget_reply_notice_failed = /** @type {(inputs: Widget_Reply_Notice_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Something went wrong. Open the chat to try again.`)
};

export const widget_reply_notice_new = /** @type {(inputs: Widget_Reply_Notice_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You have a new reply.`)
};

export const widget_request_already_sent_title = /** @type {(inputs: Widget_Request_Already_Sent_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You already sent this request`)
};

export const widget_request_back = /** @type {(inputs: Widget_Request_BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Back to conversation`)
};

export const widget_request_load_failed_text = /** @type {(inputs: Widget_Request_Load_Failed_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your draft is still here. Please try again.`)
};

export const widget_request_load_failed_title = /** @type {(inputs: Widget_Request_Load_Failed_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We couldn’t load this request`)
};

export const widget_request_loading_text = /** @type {(inputs: Widget_Request_Loading_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your conversation stays right here.`)
};

export const widget_request_loading_title = /** @type {(inputs: Widget_Request_Loading_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Loading your request`)
};

export const widget_request_meta = /** @type {(inputs: Widget_Request_MetaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Request ${i?.id}`)
};

export const widget_request_meta_time = /** @type {(inputs: Widget_Request_Meta_TimeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Request ${i?.id} · ${i?.time}`)
};

export const widget_request_receipt_sent = /** @type {(inputs: Widget_Request_Receipt_SentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your request has been sent`)
};

export const widget_request_send_failed_text = /** @type {(inputs: Widget_Request_Send_Failed_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nothing was sent. Your details are kept.`)
};

export const widget_request_sending_text = /** @type {(inputs: Widget_Request_Sending_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please keep this open for a moment.`)
};

export const widget_request_sending_title = /** @type {(inputs: Widget_Request_Sending_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sending your request`)
};

export const widget_request_try_again = /** @type {(inputs: Widget_Request_Try_AgainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Try again`)
};

export const widget_resize_height_help = /** @type {(inputs: Widget_Resize_Height_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Drag up or down to change the height, or use the up and down arrow keys. Hold Shift for larger steps. Press Home to reset the height.`)
};

export const widget_resize_height_label = /** @type {(inputs: Widget_Resize_Height_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resize conversation height`)
};

export const widget_resize_help = /** @type {(inputs: Widget_Resize_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Drag to resize, or use arrow keys. Hold Shift for larger steps. Press Home to reset the size.`)
};

export const widget_resize_label = /** @type {(inputs: Widget_Resize_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resize conversation`)
};

export const widget_review_contact_email = /** @type {(inputs: Widget_Review_Contact_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contact email`)
};

export const widget_review_edit = /** @type {(inputs: Widget_Review_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Edit details`)
};

export const widget_review_full_request = /** @type {(inputs: Widget_Review_Full_RequestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Full request`)
};

export const widget_review_info = /** @type {(inputs: Widget_Review_InfoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We’ll email the store with your request and contact email. The store can reply to you directly.`)
};

export const widget_review_not_now = /** @type {(inputs: Widget_Review_Not_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Not now`)
};

export const widget_review_request_type = /** @type {(inputs: Widget_Review_Request_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Request type`)
};

export const widget_review_send = /** @type {(inputs: Widget_Review_SendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Send request`)
};

export const widget_review_title = /** @type {(inputs: Widget_Review_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Review your request`)
};

export const widget_review_to = /** @type {(inputs: Widget_Review_ToInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`To`)
};

export const widget_seen_clear = /** @type {(inputs: Widget_Seen_ClearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clear`)
};

export const widget_seen_current = /** @type {(inputs: Widget_Seen_CurrentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title}, on the board now`)
};

export const widget_seen_label = /** @type {(inputs: Widget_Seen_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seen`)
};

export const widget_seen_mentioned = /** @type {(inputs: Widget_Seen_MentionedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title}, the one you mentioned`)
};

export const widget_select_placeholder = /** @type {(inputs: Widget_Select_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select an option`)
};

export const widget_sheet_close = /** @type {(inputs: Widget_Sheet_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Close`)
};

export const widget_shortlist_compare = /** @type {(inputs: Widget_Shortlist_CompareInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Compare ${i?.count} selected`)
};

export const widget_shortlist_compare_toggle = /** @type {(inputs: Widget_Shortlist_Compare_ToggleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compare`)
};

export const widget_shortlist_hidden = /** @type {(inputs: Widget_Shortlist_HiddenInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Show ${i?.count} more`)
};

export const widget_shortlist_level = /** @type {(inputs: Widget_Shortlist_LevelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.value} of ${i?.max}`)
};

export const widget_shortlist_open = /** @type {(inputs: Widget_Shortlist_OpenInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Open ${i?.title}`)
};

export const widget_size_heading = /** @type {(inputs: Widget_Size_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recommended size`)
};

export const widget_size_recommended = /** @type {(inputs: Widget_Size_RecommendedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recommended size`)
};

export const widget_size_source = /** @type {(inputs: Widget_Size_SourceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Source:`)
};

export const widget_size_us = /** @type {(inputs: Widget_Size_UsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`US ${i?.size}`)
};

export const widget_support_available = /** @type {(inputs: Widget_Support_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In stock`)
};

export const widget_support_conflict = /** @type {(inputs: Widget_Support_ConflictInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This request has a newer version. Your input is kept. Review the latest version before saving.`)
};

export const widget_support_copy_failed = /** @type {(inputs: Widget_Support_Copy_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Could not copy the summary. Please select and copy the text below.`)
};

export const widget_support_copy_success = /** @type {(inputs: Widget_Support_Copy_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Summary copied.`)
};

export const widget_support_expired = /** @type {(inputs: Widget_Support_ExpiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This request has expired. Ask for help again in the conversation.`)
};

export const widget_support_expired_title = /** @type {(inputs: Widget_Support_Expired_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Request expired`)
};

export const widget_support_failed = /** @type {(inputs: Widget_Support_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Could not save this request. Your input is kept. Please try again.`)
};

export const widget_support_field_error = /** @type {(inputs: Widget_Support_Field_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Check this field. It may be missing, invalid, or too long.`)
};

export const widget_support_inaccessible = /** @type {(inputs: Widget_Support_InaccessibleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This request is no longer accessible. You can ask for help again in the conversation.`)
};

export const widget_support_latest = /** @type {(inputs: Widget_Support_LatestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Use latest version`)
};

export const widget_support_loading = /** @type {(inputs: Widget_Support_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Loading request…`)
};

export const widget_support_observed_at = /** @type {(inputs: Widget_Support_Observed_AtInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Snapshot recorded at ${i?.time}`)
};

export const widget_support_open_unavailable = /** @type {(inputs: Widget_Support_Open_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The store contact form is temporarily unavailable. Please try the store’s other contact options.`)
};

export const widget_support_open_unavailable_title = /** @type {(inputs: Widget_Support_Open_Unavailable_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contact form unavailable`)
};

export const widget_support_pause_failed = /** @type {(inputs: Widget_Support_Pause_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Could not pause this request. Your input is kept. Please try again.`)
};

export const widget_support_paused = /** @type {(inputs: Widget_Support_PausedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Draft saved. Resume whenever you are ready.`)
};

export const widget_support_quantity = /** @type {(inputs: Widget_Support_QuantityInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Qty ${i?.quantity}`)
};

export const widget_support_rate_limited = /** @type {(inputs: Widget_Support_Rate_LimitedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Too many requests. Please wait before trying again.`)
};

export const widget_support_read_failed = /** @type {(inputs: Widget_Support_Read_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We couldn’t load this request. Please try again.`)
};

export const widget_support_reference = /** @type {(inputs: Widget_Support_ReferenceInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Request ${i?.id}`)
};

export const widget_support_resume = /** @type {(inputs: Widget_Support_ResumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resume request`)
};

export const widget_support_resume_failed = /** @type {(inputs: Widget_Support_Resume_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Could not resume this request. Your draft is kept. Please try again.`)
};

export const widget_support_retry = /** @type {(inputs: Widget_Support_RetryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reload request`)
};

export const widget_support_save = /** @type {(inputs: Widget_Support_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Save draft`)
};

export const widget_support_saved = /** @type {(inputs: Widget_Support_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Draft saved. No email has been sent.`)
};

export const widget_support_scope = /** @type {(inputs: Widget_Support_ScopeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Request scope`)
};

export const widget_support_send_failed = /** @type {(inputs: Widget_Support_Send_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Could not send this request. Check its status before trying again.`)
};

export const widget_support_send_not_configured = /** @type {(inputs: Widget_Support_Send_Not_ConfiguredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Email sending is unavailable right now. Nothing was sent, and your request is kept.`)
};

export const widget_support_snapshot = /** @type {(inputs: Widget_Support_SnapshotInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.facts} · Snapshot: ${i?.time}`)
};

export const widget_support_store_unavailable = /** @type {(inputs: Widget_Support_Store_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This store cannot receive requests here right now. Your request has not been sent.`)
};

export const widget_support_unavailable = /** @type {(inputs: Widget_Support_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Out of stock`)
};

export const widget_support_unavailable_title = /** @type {(inputs: Widget_Support_Unavailable_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Request unavailable`)
};

export const widget_unavailable_contact_page = /** @type {(inputs: Widget_Unavailable_Contact_PageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contact page ·`)
};

export const widget_unavailable_copy = /** @type {(inputs: Widget_Unavailable_CopyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copy summary`)
};

export const widget_unavailable_message = /** @type {(inputs: Widget_Unavailable_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The store’s email isn’t available right now, so nothing was sent.`)
};

export const widget_unavailable_other_way = /** @type {(inputs: Widget_Unavailable_Other_WayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reach the store another way`)
};

export const widget_unavailable_phone = /** @type {(inputs: Widget_Unavailable_PhoneInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Phone · ${i?.number}`)
};

export const widget_unavailable_title = /** @type {(inputs: Widget_Unavailable_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We couldn’t send your request`)
};

export const widget_unsent_label = /** @type {(inputs: Widget_Unsent_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unsent request`)
};

export const widget_unsent_resume = /** @type {(inputs: Widget_Unsent_ResumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resume request`)
};

export const widget_unsent_status = /** @type {(inputs: Widget_Unsent_StatusInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.type} · Not sent`)
};

export const widget_unsent_title = /** @type {(inputs: Widget_Unsent_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Request to the store`)
};

export const widget_verification_code_digit = /** @type {(inputs: Widget_Verification_Code_DigitInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Digit ${i?.index} of ${i?.length}`)
};

export const widget_verification_code_label = /** @type {(inputs: Widget_Verification_Code_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verification code`)
};

export const widget_verification_request_action = /** @type {(inputs: Widget_Verification_Request_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sign in`)
};

export const widget_verification_request_description = /** @type {(inputs: Widget_Verification_Request_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sign in to your store account. We’ll bring you back here to continue your question.`)
};

export const widget_verification_request_expired = /** @type {(inputs: Widget_Verification_Request_ExpiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This sign-in request is no longer active. Ask to check your order again.`)
};

export const widget_verification_request_pending = /** @type {(inputs: Widget_Verification_Request_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please wait…`)
};

export const widget_verification_request_title = /** @type {(inputs: Widget_Verification_Request_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sign in to check your order`)
};

export const widget_verify_code_expired = /** @type {(inputs: Widget_Verify_Code_ExpiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This code has expired. Get a new code to continue.`)
};

export const widget_verify_code_hint = /** @type {(inputs: Widget_Verify_Code_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The code works for 10 minutes.`)
};

export const widget_verify_code_wrong = /** @type {(inputs: Widget_Verify_Code_WrongInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`That code didn’t match. Check it and try again — ${i?.tries} tries left.`)
};

export const widget_verify_code_wrong_last = /** @type {(inputs: Widget_Verify_Code_Wrong_LastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`That code didn’t match. Check it and try again — 1 try left.`)
};

export const widget_verify_confirm = /** @type {(inputs: Widget_Verify_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verify email`)
};

export const widget_verify_contact_store = /** @type {(inputs: Widget_Verify_Contact_StoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contact store`)
};

export const widget_verify_email_action = /** @type {(inputs: Widget_Verify_Email_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Email verification`)
};

export const widget_verify_email_invalid = /** @type {(inputs: Widget_Verify_Email_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter a full email address, like name@example.com.`)
};

export const widget_verify_email_label = /** @type {(inputs: Widget_Verify_Email_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Email used at checkout`)
};

export const widget_verify_email_placeholder = /** @type {(inputs: Widget_Verify_Email_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`you@example.com`)
};

export const widget_verify_failed = /** @type {(inputs: Widget_Verify_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We couldn’t complete verification. Please try again.`)
};

export const widget_verify_intro = /** @type {(inputs: Widget_Verify_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We’ll email you a one-time code.`)
};

export const widget_verify_locked = /** @type {(inputs: Widget_Verify_LockedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Too many attempts. Please wait before requesting another code.`)
};

export const widget_verify_playground_action = /** @type {(inputs: Widget_Verify_Playground_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verify email`)
};

export const widget_verify_resend = /** @type {(inputs: Widget_Verify_ResendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resend code`)
};

export const widget_verify_resend_in = /** @type {(inputs: Widget_Verify_Resend_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resend code in`)
};

export const widget_verify_send = /** @type {(inputs: Widget_Verify_SendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Send verification code`)
};

export const widget_verify_success = /** @type {(inputs: Widget_Verify_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Email verified`)
};

export const widget_verify_title = /** @type {(inputs: Widget_Verify_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verify your email`)
};

export const widget_verify_unavailable = /** @type {(inputs: Widget_Verify_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Email verification is unavailable. Please use store login.`)
};

export const widget_verify_unknown = /** @type {(inputs: Widget_Verify_UnknownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The email may have been sent. Enter the code if you received it, or resend after the cooldown.`)
};

export const widget_voice_answering = /** @type {(inputs: Widget_Voice_AnsweringInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Answering`)
};

export const widget_voice_closed = /** @type {(inputs: Widget_Voice_ClosedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The voice connection closed.`)
};

export const widget_voice_connecting = /** @type {(inputs: Widget_Voice_ConnectingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connecting to voice…`)
};

export const widget_voice_disable = /** @type {(inputs: Widget_Voice_DisableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Turn off voice`)
};

export const widget_voice_enable = /** @type {(inputs: Widget_Voice_EnableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Use voice`)
};

export const widget_voice_ended = /** @type {(inputs: Widget_Voice_EndedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voice call ended. Turn voice on to continue.`)
};

export const widget_voice_error = /** @type {(inputs: Widget_Voice_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voice error`)
};

export const widget_voice_listening = /** @type {(inputs: Widget_Voice_ListeningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Listening`)
};

export const widget_voice_occupied = /** @type {(inputs: Widget_Voice_OccupiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voice is in use on another device.`)
};

export const widget_voice_replaced = /** @type {(inputs: Widget_Voice_ReplacedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voice was taken over by another connection.`)
};

export const widget_voice_revoked = /** @type {(inputs: Widget_Voice_RevokedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voice access was revoked for this device.`)
};

export const widget_voice_turn_failed = /** @type {(inputs: Widget_Voice_Turn_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sorry, I couldn't answer that. Please ask again.`)
};